"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftActionsSectionRoot = void 0;
var _mui = require("@ori-ui/mui");
const LeftActionsSectionRoot = exports.LeftActionsSectionRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    maxWidth: 'none'
  },
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(4)
  },
  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(8)
  }
}));